export default __webpack_public_path__ + "a4ef2aa38a6d9fb571891c9fdc4f23f7.png";